import React from "react";
import { NavLink } from "react-router-dom";
// import { useState } from "react";

export const PageModalApp = (props) => {
  return (
    <div className="col-2" key={props.dataTarget}>
      <button
        type="button"
        className="btn  btn-block"
        data-toggle="modal"
        data-target={props.dataTarget}
        style={{ margin: 0, padding: 0 }}
      >
        <img
          src={props.src}
          alt={props.dataTarget}
          className="card btn col-sm"
          style={{
            margin: "0",
            padding: "0",
            borderRadius: "20%",
            overflow: "hidden",
          }}
        />
      </button>
      <h4 style={{ textAlign: "center" }}>{props.title} </h4>
    </div>
  );
};

export const PageLinkApp = (props) => {
  return (
    <>
      <div className="col-2" key={props.id}>
        <NavLink
          className="nav-link"
          activeClassName="active"
          to={props.linkTo}
          style={{
            padding: "0",
          }}
        >
          <button
            type="button"
            className="btn  btn-block"
            style={{ margin: "0", padding: "0" }}
          >
            <img
              src={props.src}
              alt={props.id}
              className="card btn col-sm"
              style={{
                margin: "0",
                padding: "0",
                borderRadius: "20%",
                overflow: "hidden",
              }}
            />
          </button>
          <h4 style={{ textAlign: "center" }}>{props.title} </h4>
        </NavLink>
      </div>
    </>
  );
};

export const CarouselCards = (props) => {
  // const [hovered, setHovered] = useState(false);
  // const mouseOver = () => {
  //   setHovered(true);
  // };

  // const mouseExit = () => {
  //   setHovered(false);
  // };

  return (
    <div className="col ">
      <div
        className="card"
        style={{
          borderRadius: 10,
          marginTop: 25,
          marginBottom: 25,
        }}
      >
        <figure>
          <img
            src={props.src}
            alt={props.alt}
            style={{ objectFit: "contain" }}
          />
        </figure>
        <div className="card-body" style={{ height: "220px" }}>
          <dl>
            <dt>{props.title}</dt>
            <dd>{props.titleDesc}</dd>
          </dl>
          <div>
            <p
              className="card-text"
              // style={hovered ? { display: "block " } : { display: "none" }}
            >
              {props.description}
            </p>
          </div>
        </div>
        <div className="card-footer d-flex justify-content-center ">
          <div>
            <a
              href={props.link}
              target="_blank"
              className="btn btn-primary btn-lg"
              style={{ textAlign: "center", borderRadius: 10, marginBottom: 5 }}
            >
              VIEW
              {/* <button className="btn btn-primary ">VIEW</button> */}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
